"use client";

import IconArrowRightLong from "@/app/(components)/generics/Icons/IconArrowRightLong";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import homeStyles from "../../Home.module.css";
import { WHY_FRAGMENTS } from "./WhyMeidly.logic";
import styles from "./WhyMeidly.module.css";

export default function WhyMeidly() {
  const T = useT();

  return (
    <div className={styles.container}>
      <div className={styles.head}>
        <span className={homeStyles.supTitle}>{T(TKey.HOME_MEIDLY_WHY_SUP_TITLE)}</span>
        <h2 className={homeStyles.statement}>{T(TKey.HOME_MEIDLY_WHY_TITLE)}</h2>
      </div>

      <div className={styles.chaos}>
        {WHY_FRAGMENTS.map((key) => (
          <span className={styles.fragment} key={key}>
            {T(key)}
          </span>
        ))}
      </div>

      <div className={styles.resolution}>
        <span className={styles.resolutionArrow} aria-hidden="true">
          <IconArrowRightLong size={26} />
        </span>

        <p className={styles.resolutionText}>{T(TKey.HOME_MEIDLY_WHY_RESOLUTION_1)}</p>
        <span className={styles.resolutionSplit} />
        <p className={`${styles.resolutionText} ${styles.resolutionEmphasis}`}>
          {T(TKey.HOME_MEIDLY_WHY_RESOLUTION_2)}
        </p>
      </div>
    </div>
  );
}
